import { Injectable } from '@angular/core';
import { AngularFirestore } from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import { Observable } from "rxjs";
import { CounsellingInduction } from "./counselling-induction.model";

@Injectable({
  providedIn: 'root'
})
export class CounselingInductionService {

  private collection = this.firestore.collection<CounsellingInduction>('counsellingInduction');
  private collectionView = this.firestore.collection<CounsellingInduction>('counsellingInduction-view-data');

  constructor(private firestore: AngularFirestore) {}
  createEmptyDocument() {
    return this.collection.add({
      inductionFor: '',
      submittedBy: '',
      rows: [],
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  create(data: CounsellingInduction): Promise<any> {
    return this.collection.add({
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }
  // UPDATE existing induction
  update(id: string, data: any): Promise<void> {
    return this.collection.doc(id)
      .update({
        ...data,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
  }
  getById(id: string) {
    return this.collection.doc(id).valueChanges({ idField: "id" });
  }

  addDocument(data: any) {
    return this.collection.add({
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
  }

  updateRows(id: string, rows: any[]): Promise<void> {
    return this.collection.doc(id).update({
      rows: rows,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  getDataById(id: string): Observable<CounsellingInduction | undefined> {
    return this.collection.doc<CounsellingInduction>(id).valueChanges({ idField: 'id' });
  }

  // getAll(): Observable<CounsellingInduction[]> {
  //   return this.collection.valueChanges({ idField: 'id' });
  // }

  getAll() {
    return this.firestore.collection(
      'counsellingInduction',
      ref => ref.orderBy('createdAt', 'desc')
    ).valueChanges({ idField: 'id' });
  }

  getAllViewData(): Observable<CounsellingInduction[]> {
    return this.collectionView.valueChanges({ idField: 'id' });
  }

  delete(id: string): Promise<void> {
    return this.collection.doc(id).delete();
  }
}
